import { MOFF_CHECK_V1_VALUE_LIST, MoffCheckV1SelectList } from '../constants/MoffCheck';

const STORAGE_KEY_PREFIX = 'moffCheckSelectedItems';
const DEFAULT_ITEMS: string[] = ['CS-30'];
const MAX_ITEMS = 2;

const buildKey = (userName: string): string => `${STORAGE_KEY_PREFIX}_${userName}`;

const isValidItem = (item: unknown): item is MoffCheckV1SelectList =>
  typeof item === 'string' && (MOFF_CHECK_V1_VALUE_LIST as readonly string[]).includes(item);

// userName単位で前回選択した追加項目を取得する。
// 不正値・未保存・userName未設定時は既定の ['CS-30'] を返す。
export const getMoffCheckSelectedItems = (userName: string): string[] => {
  if (!userName) return [...DEFAULT_ITEMS];
  try {
    const raw = localStorage.getItem(buildKey(userName));
    if (raw === null) return [...DEFAULT_ITEMS];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [...DEFAULT_ITEMS];
    const valid = parsed.filter(isValidItem).slice(0, MAX_ITEMS);
    return valid.length > 0 ? valid : [...DEFAULT_ITEMS];
  } catch {
    return [...DEFAULT_ITEMS];
  }
};

// 追加項目選択を userName 単位で保存する。userName未設定時は何もしない。
export const setMoffCheckSelectedItems = (userName: string, items: string[]): void => {
  if (!userName) return;
  try {
    localStorage.setItem(buildKey(userName), JSON.stringify(items));
  } catch {
    // localStorage が利用不可の場合は黙って無視する（プライベートモード等）
  }
};
